import { isDevEnvironment, isDevDomain } from "@/utils/utils";
import axios, { Axios, AxiosError, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { StorageService } from "./storageService";
import { RefreshTokenResponse } from "@/modules/api";
import { store } from "@/store";

export class HttpService {
  static #instance: HttpService;
  httpClient: Axios

  private constructor() {
    this.httpClient = axios.create();
    
    this.httpClient.interceptors.request.use(
      (config) => this.#requestInterceptor(config),
      (error) => Promise.reject(error)
    )
    this.httpClient.interceptors.response.use(
      (response) => response,
      (error) => this.#errorInterceptor(error)
    );
  }

  public static get instance() {
    if (!this.#instance) {
      this.#instance = new HttpService();
    }

    return this.#instance;
  }

  static get baseUrl() {
    return isDevEnvironment()
		? "http://localhost:9001/b2b"
		: !isDevDomain()
			? "https://api-go.3bmeteo.com/b2b"
			: "https://api-go-dev.3bmeteo.com/b2b"
  }

  async #requestInterceptor(config: InternalAxiosRequestConfig) {
    const storageService = StorageService.instance;

    if (storageService.getJWTToken() != null) {
      config.headers.Authorization = `Bearer ${storageService.getJWTToken()}`;
    }

    return config;
  }

  async #errorInterceptor(error: AxiosError) {
    const storageService = StorageService.instance;
    const originalRequest = error.config;
    const isRetry = ( originalRequest?.params && originalRequest?.params.isRetry === true ) || ( originalRequest?.url && originalRequest.url.includes('/refreshToken') );

    if (error.response && error.response.status == 401 && originalRequest && !isRetry) {
      originalRequest.params = { ...originalRequest.params, isRetry: true }

      const refreshTokenResponse = await HttpService.#refreshToken();
      const body: RefreshTokenResponse = refreshTokenResponse.data
      storageService.setJwtToken(body.data.jwtToken)

      originalRequest.headers['Authorization'] = 'Bearer ' + body.data.jwtToken;

      try {
        const response = await HttpService.instance.request(originalRequest);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
        
      }
    } if (error.response && error.response.status == 401 && originalRequest && isRetry) {
      store.dispatch("logout")
      return Promise.resolve();
    } else {
      return Promise.reject(error);
    }
  }

  static async #refreshToken() {
    const storageService = StorageService.instance;
    const httpService = HttpService.instance;
    return httpService.post({ url: `/refreshToken`, data: { refreshToken: storageService.getRefreshToken() } })
  }

  async get(params: { url: string }): Promise<AxiosResponse> {
    return this.httpClient.get(`${HttpService.baseUrl}${params.url}`);
  }

  async post(params: { url: string, data?: any }): Promise<AxiosResponse> {
    return this.httpClient.post(`${HttpService.baseUrl}${params.url}`, params.data);
  }

  async request(config: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.httpClient.request(config);
  }
}
